module.exports = __webpack_public_path__ + "img/news-frame.5f7495df.svg";